var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-d83ea99a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "user-info" };
var _hoisted_2 = { class: "flex flex-col px-4 mb-5 leading-none" };
var _hoisted_3 = ["textContent"];
var _hoisted_4 = { class: "text-sm font-medium opacity-40" };
var _hoisted_5 = { class: "user-info__actions" };
var _hoisted_6 = {
    key: 0,
    class: "user-info__link group",
    href: "https://skillspace.ru/changelog",
    target: "_blank"
};
var _hoisted_7 = {
    key: 1,
    class: "user-info__link group",
    href: "https://help.skillspace.ru/",
    target: "_blank"
};
var _hoisted_8 = { class: "mt-5 w-full" };
import { computed, ref } from 'vue';
import { CoreStore } from '@common/stores';
import Auth from '@common/modules/auth';
import EIcon from '@common/ui/EIcon.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserInfo',
    setup: function (__props) {
        var _this = this;
        var t = useI18n().t;
        var logoutLoading = ref(false);
        var auth = computed(function () { return Auth; });
        var user = computed(function () { return CoreStore.user; });
        var whiteLabelHideLogo = computed(function () { return CoreStore.schoolSettings.whiteLabelHideLogo; });
        var logout = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logoutLoading.value = true;
                        return [4 /*yield*/, auth.value.logout()];
                    case 1:
                        _a.sent();
                        logoutLoading.value = false;
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _component_e_link = _resolveComponent("e-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", {
                        class: "font-bold mb-2.5",
                        textContent: _toDisplayString(user.value.name || user.value.email)
                    }, null, 8, _hoisted_3),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('user.role')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_e_link, {
                        "href-to": { name: 'profile' },
                        class: "inline-flex items-center gap-x-4 px-4 py-2.5 font-bold text-gray-500/60 hover:bg-gray-100 hover:text-gray-500 rounded-lg transition-colors leading-none group"
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(EIcon, {
                                class: "icon group-hover:text-primary",
                                icon: "user"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('user.myProfile')), 1)
                        ]; }),
                        _: 1
                    }),
                    (!whiteLabelHideLogo.value || (whiteLabelHideLogo.value && _unref(Auth).isSchoolOwner()))
                        ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                            _createVNode(EIcon, {
                                class: "icon group-hover:text-primary",
                                icon: "star-role"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('user.whatIsNew')), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (!whiteLabelHideLogo.value || (whiteLabelHideLogo.value && _unref(Auth).isSchoolOwner()))
                        ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                            _createVNode(EIcon, {
                                class: "icon group-hover:text-primary",
                                icon: "help-circle"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('user.help')), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                        class: "user-info__link group w-full",
                        onClick: logout
                    }, [
                        _createVNode(EIcon, {
                            class: "icon group-hover:text-red-500",
                            icon: "logout-rounded"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('user.logout')), 1)
                    ])
                ])
            ]));
        };
    }
});
